import React from 'react';
import '../Styles/StarProduct.css'

const StarProduct = ({starProduct}) => {
  return (
    <div className='product'>
        <div>
            <a href={starProduct[0].url}><img src={starProduct[0].image} alt="1 product"/></a>
        </div>
        <div>
            <a href={starProduct[1].url}><img src={starProduct[1].image} alt="2 product"/></a>
            <a href={starProduct[2].url}><img src={starProduct[2].image} alt="3 product"/></a>
            <a href={starProduct[3].url}><img src={starProduct[3].image} alt="4 product"/></a>
        </div>
    </div>
  )
};

export default StarProduct